/* @flow */

// Utils
import { getEventPlugins } from '@braindate/domain/lib/event/util';
import { queueNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { expressionOfGratitudePlugin as expressionOfGratitudePluginKey } from 'src/shared/app/feature/settings/featureSettings';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import { isFishbowlTopic } from '@braindate/domain/lib/topic/util';
import { getBraindateTopic } from 'src/shared/domain/braindate/util/braindateUtil';
import {
  buildExpressionOfGratitudePostBraindateNotification,
  buildExpressionOfGratitudeRecipientNotification,
} from 'src/shared/app/expression-of-gratitude/notification/expressionOfGratitudeNotification';

// Types
import type { User } from '@braindate/domain/lib/user/type';
import type { State } from 'src/shared/core/type/reduxTypes';
import type { Braindate } from '@braindate/domain/lib/braindate/type';
import type { ExpressionOfGratitude } from '@braindate/domain/lib/expressionOfGratitude/type';

export function showExpressionOfGratitudePostBraindateModal(
  braindate: Braindate,
) {
  return (dispatch: any, getState: () => State) => {
    const event = getEventSafely(getState());

    const topic = getBraindateTopic(braindate);
    if (isFishbowlTopic(topic)) return null;

    const expressionOfGratitudePlugin =
      getEventPlugins(event)[expressionOfGratitudePluginKey];

    if (!expressionOfGratitudePlugin) return null;

    return dispatch(
      queueNotification(
        buildExpressionOfGratitudePostBraindateNotification(braindate),
      ),
    );
  };
}

export function showExpressionOfGratitudePostBraindateModalBundle(
  braindates: Array<Braindate>,
) {
  return (dispatch: any) =>
    braindates.map<Braindate>((braindate) =>
      dispatch(showExpressionOfGratitudePostBraindateModal(braindate)),
    );
}

export function showExpressionOfGratitudeRecipientModal(
  expressionOfGratitude: ExpressionOfGratitude,
) {
  return queueNotification(
    buildExpressionOfGratitudeRecipientNotification(expressionOfGratitude),
  );
}

export function parseEligibleParticipants(
  eligibleParticipants: Array<User>,
  braindateParticipants: Array<User>,
): Array<User> {
  const indexedEligible = new Set();

  eligibleParticipants.forEach((p) => {
    indexedEligible.add(p.id);
  });

  return braindateParticipants.filter((participant) =>
    indexedEligible.has(participant.id),
  );
}
